import React from "react";

import imgA1 from "../../assets/image/inner-page/png/arrow-1.png";
import imgA2 from "../../assets/image/inner-page/png/arrow-2.png";

const Progress = ({ className, ...rest }) => {
  return (
    <>
      <div className={className} {...rest}>
        <div className="container">
          {/* <!-- Section Title --> */}
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-8 col-md-9 col-xs-10">
              <div className="text-center pt-13 pt-lg-23 pb-13 pb-lg-12 pr-lg-10 pr-xl-0">
                <h2 className="font-size-11 mb-0">
                  Sube de nivel con Timeview totalmente gratis
                </h2>
              </div>
            </div>
          </div>
          {/* <!-- Section Title --> */}
          {/* <!-- Progress Items --> */}
          <div className="row justify-content-center">
            <div className="col-sm-12 col-xs-8">
              <div className="timeline-area d-sm-flex just justify-content-lg-between flex-wrap flex-lg-nowrap position-relative">
                {/* <!-- Image Group --> */}
                <div className="image-group-3">
                  <div
                    className="arrow-shape-1 d-none d-lg-block absolute-top-left"
                    data-aos="zoom-in"
                    data-aos-delay="600"
                    data-aos-once="true"
                  >
                    <img src={imgA1} alt="" />
                  </div>
                  <div
                    className="arrow-shape-2 d-none d-lg-block absolute-top-right"
                    data-aos="zoom-in"
                    data-aos-delay="1100"
                    data-aos-once="true"
                  >
                    <img src={imgA2} alt="" />
                  </div>
                </div>
                {/* <!-- Single Progress --> */}
                <div
                  className="single-widgets pr-md-18 pr-lg-0 pl-lg-10 pl-xl-22 mb-10 mb-lg-0 text-center text-md-left"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                  data-aos-once="true"
                >
                  <div className="square-97 bg-blue-3 rounded-10 mb-10 shadow-dodger-blue-3 mx-auto mx-md-0 font-size-9 text-white">
                    <i className="fa fa-info" />
                  </div>
                  <div className="">
                    <h3 className="font-size-8 mb-6">Solicita información</h3>
                    <p className="font-size-5 line-height-28 mb-0">
                      Ponte en contacto con nosotros a través del formulario
                    </p>
                  </div>
                </div>
                {/* <!-- End Single Progress --> */}
                {/* <!-- Single Progress --> */}
                <div
                  className="single-widgets pr-md-18 pr-lg-0 pl-lg-10 pl-xl-22 mb-10 mb-lg-0 text-center text-md-left"
                  data-aos="zoom-in"
                  data-aos-delay="900"
                  data-aos-once="true"
                >
                  <div className="square-97 bg-sunset rounded-10 mb-10 shadow-sunset mx-auto mx-md-0 font-size-9 text-white">
                    <i className="fa fa-heart" />
                  </div>
                  <div className="">
                    <h3 className="font-size-8 mb-6">
                      Déjalo en nuestras manos
                    </h3>
                    <p className="font-size-5 line-height-28 mb-0">
                      Nuestros asesores encontrarán el plan que mejor se adapte
                      a tu empresa y se encargarán de todos los trámites.
                    </p>
                  </div>
                </div>
                {/* <!-- End Single Progress --> */}
                {/* <!-- Single Progress --> */}
                <div
                  className="single-widgets pr-md-18 pr-lg-0 pl-lg-10 pl-xl-22 mb-10 mb-lg-0 text-center text-md-left"
                  data-aos="zoom-in"
                  data-aos-delay="1300"
                  data-aos-once="true"
                >
                  <div className="square-97 bg-neon-green rounded-10 mb-10 shadow-neon-green mx-auto mx-md-0 font-size-9 text-white">
                    <i className="fa fa-mug-hot" />
                  </div>
                  <div className="">
                    <h3 className="font-size-8 mb-6">¡Y ya está!</h3>
                    <p className="font-size-5 line-height-28 mb-0">
                      Disfruta de la experiencia Timeview durante al menos un
                      año
                    </p>
                  </div>
                </div>
                {/* <!-- End Single Progress --> */}
              </div>
            </div>
          </div>
          {/* <!-- End Progress Items --> */}
        </div>
      </div>
    </>
  );
};

export default Progress;
